import html2pdf from "html2pdf.js";
import * as XLSX from "xlsx";

// export const exportToExcel = (data, filename, generatedBy, startDate, endDate) => {
//   const wb = XLSX.utils.book_new();
//   const ws_data = [];
//   const headerMapping = {
//     equipment: "Equipment",
//     unit: "Unit",
//     date: "Date",
//     equipmentMaterial: "Material",
//     start: "Start Time",
//     end: "End Time",
//     remark: "Remark",
//     totalHours: "Total",
//     trip: "Trip",
//     diesel: "Diesel",
//     number: "Quantity",
//   };

//   const headerOrder = [
//     "equipment",
//     "unit",
//     "date",
//     "equipmentMaterial",
//     "start",
//     "end",
//     "remark",
//     "totalHours",
//     "trip",
//     "diesel",
//     "number",
//   ];

//   data.forEach((item) => {
//     // Add project name as a header
//     ws_data.push([`Project Name: ${item.projectName}`]);

//     if (item.data.length > 0) {
//       // Map and order headers
//       const headers = headerOrder.map((key) => headerMapping[key]);
//       ws_data.push(headers);

//       // Map and order rows based on the headerOrder, excluding "countUnit"
//       item.data.forEach((row) => {
//         const rowData = headerOrder.map((key) => row[key] ?? "");
//         ws_data.push(rowData);
//       });
//     } else {
//       ws_data.push(["No data available"]);
//     }

//     ws_data.push([], []);
//   });

//   const ws = XLSX.utils.aoa_to_sheet(ws_data);

//   const columnWidths = [
//     { wch: 20 }, // Equipment
//     { wch: 10 }, // Unit
//     { wch: 15 }, // Date
//     { wch: 20 }, // Material
//     { wch: 15 }, // Start Time
//     { wch: 15 }, // End Time
//     { wch: 30 }, // Remark
//     { wch: 10 }, // Total
//     { wch: 10 }, // Trip
//     { wch: 10 }, // Diesel
//     { wch: 10 }, // Quantity
//   ];

//   ws["!cols"] = columnWidths;

//   XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

//   XLSX.writeFile(wb, `${filename}.xlsx`);
// };

export const exportToExcel = (
  data,
  filename,
  generatedBy,
  startDate,
  endDate,
  reportFormat = "Equipment Wise"
) => {
  const wb = XLSX.utils.book_new();
  const ws_data = [];

  // Add title
  ws_data.push(["Equipment Report - All Projects"]);
  ws_data.push([]);
  
  // Add metadata
  const generatedOn = new Date().toLocaleDateString();
  ws_data.push([
    `Generated By: ${generatedBy || "N/A"}`,
    `Generated On: ${generatedOn}`,
    `Start Date: ${startDate || "N/A"}`,
    `End Date: ${endDate || "N/A"}`,
  ]);
  ws_data.push([]);

  const headerMapping = {
    equipment: "Equipment",
    projectName: "Project Name",
    unit: "Unit",
    date: "Date",
    equipmentMaterial: "Material",
    start: "Start Time",
    end: "End Time",
    remark: "Remark",
    totalHours: "Total",
    trip: "Trip",
    diesel: "Diesel",
    number: "Quantity",
  };

  // Define header order based on report format (matching your React component)
  let headerOrder = [];
  
  if (reportFormat === "Equipment Wise") {
    headerOrder = [
      "equipment",
      "projectName",
      "unit",
      "date",
      "equipmentMaterial",
      "start",
      "end",
      "remark",
      "totalHours",
      "trip",
      "diesel",
      "number",
    ];
  } else if (reportFormat === "Material Wise") {
    headerOrder = [
      "equipmentMaterial",
      "projectName",
      "equipment",
      "unit",
      "date",
      "start",
      "end",
      "remark",
      "totalHours",
      "trip",
      "diesel",
      "number",
    ];
  } else if (reportFormat === "Date Wise") {
    headerOrder = [
      "date",
      "projectName",
      "equipment",
      "unit",
      "equipmentMaterial",
      "start",
      "end",
      "remark",
      "totalHours",
      "trip",
      "diesel",
      "number",
    ];
  }

  // Add column headers
  const headers = headerOrder.map(key => headerMapping[key]);
  ws_data.push(headers);

  // Check data structure and flatten if needed
  let flattenedData = [];
  
  if (Array.isArray(data) && data.length > 0) {
    // Check if data is already flattened (has projectName directly) or needs flattening
    if (data[0] && data[0].projectName && !data[0].data) {
      // Data is already flattened
      flattenedData = data;
    } else if (data[0] && data[0].projectName && Array.isArray(data[0].data)) {
      // Data needs flattening - this is your original structure
      data.forEach(project => {
        if (Array.isArray(project.data)) {
          project.data.forEach(item => {
            flattenedData.push({
              ...item,
              projectName: project.projectName
            });
          });
        }
      });
    } else {
      // Assume data is already in correct format
      flattenedData = data;
    }
  }

  console.log("Flattened data sample:", flattenedData[0]);
  console.log("Expected headers:", headerOrder);

  // Add all data rows in flattened format
  if (flattenedData && flattenedData.length > 0) {
    flattenedData.forEach(row => {
      const rowData = headerOrder.map(key => {
        const value = row[key];
        // Handle null/undefined values
        return value !== null && value !== undefined ? value : "";
      });
      ws_data.push(rowData);
    });

    // Add totals row (matching your table footer)
    ws_data.push([]);
    const totalsRow = new Array(headerOrder.length).fill("");
    totalsRow[0] = "Total"; // First column shows "Total"
    
    // Calculate totals exactly like your React component
    const totals = {
      totalHours: flattenedData.reduce((sum, item) => sum + parseFloat(item.totalHours || 0), 0),
      trip: flattenedData.reduce((sum, item) => sum + parseFloat(item.trip || 0), 0),
      diesel: flattenedData.reduce((sum, item) => sum + parseFloat(item.diesel || 0), 0),
      number: flattenedData.reduce((sum, item) => sum + parseFloat(item.number || 0), 0),
    };

    // Place totals in correct columns
    const totalHoursIndex = headerOrder.indexOf("totalHours");
    const tripIndex = headerOrder.indexOf("trip");
    const dieselIndex = headerOrder.indexOf("diesel");
    const numberIndex = headerOrder.indexOf("number");

    if (totalHoursIndex !== -1) totalsRow[totalHoursIndex] = totals.totalHours.toFixed(2);
    if (tripIndex !== -1) totalsRow[tripIndex] = totals.trip.toFixed(2);
    if (dieselIndex !== -1) totalsRow[dieselIndex] = totals.diesel.toFixed(2);
    if (numberIndex !== -1) totalsRow[numberIndex] = totals.number.toFixed(2);

    ws_data.push(totalsRow);
  } else {
    ws_data.push(["No data available"]);
  }

  const ws = XLSX.utils.aoa_to_sheet(ws_data);

  // Set column widths based on content
  const columnWidths = headerOrder.map(key => {
    switch (key) {
      case "equipment":
      case "equipmentMaterial":
        return { wch: 20 };
      case "projectName":
        return { wch: 25 };
      case "remark":
        return { wch: 35 };
      case "date":
        return { wch: 12 };
      case "start":
      case "end":
        return { wch: 12 };
      case "unit":
        return { wch: 8 };
      case "totalHours":
      case "trip":
      case "diesel":
      case "number":
        return { wch: 10 };
      default:
        return { wch: 10 };
    }
  });

  ws["!cols"] = columnWidths;

  // Style the title
  if (ws["A1"]) {
    ws["A1"].s = {
      fill: { fgColor: { rgb: "4CAF50" } },
      font: { color: { rgb: "FFFFFF" }, sz: 14, bold: true },
      alignment: { horizontal: "center", vertical: "center" }
    };
  }

  // Style the headers
  const headerRowIndex = 4; // Headers are on row 5 (0-indexed as 4)
  headerOrder.forEach((_, colIndex) => {
    const cellAddress = XLSX.utils.encode_cell({ r: headerRowIndex, c: colIndex });
    if (ws[cellAddress]) {
      ws[cellAddress].s = {
        fill: { fgColor: { rgb: "E8F5E8" } },
        font: { bold: true },
        alignment: { horizontal: "center" }
      };
    }
  });

  // Merge title across all columns
  const titleRange = {
    s: { r: 0, c: 0 },
    e: { r: 0, c: headerOrder.length - 1 },
  };
  if (!ws["!merges"]) ws["!merges"] = [];
  ws["!merges"].push(titleRange);

  // Set row height for title
  if (!ws["!rows"]) ws["!rows"] = [];
  ws["!rows"][0] = { hpt: 25 };

  XLSX.utils.book_append_sheet(wb, ws, "Equipment Report");
  XLSX.writeFile(wb, `${filename}.xlsx`);
};

// export const export_To_Excel = (data, ReportFormat, generatedBy, startDate, endDate) => {
//   console.log("data>?>?>??>?>", data);

//   const flattenedData = [];

//   flattenedData.push(["Enbuild"]);
//   flattenedData.push([]);
//   const generatedOn = new Date().toLocaleDateString();
//   flattenedData.push([
//     `Generated By: \n${generatedBy || "N/A"}`,
//     `Generated On: \n${generatedOn}`,
//     `Start Date: \n${startDate || "N/A"}`,
//     `End Date: \n${endDate || "N/A"}`,
//   ]);

//   flattenedData.push([]);

//   data.forEach((elem) => {
//     let totalQuantity = 0;

//     elem.data.forEach((materialItem) => {
//       materialItem.elm.forEach((row, index) => {
//         const quantity = parseFloat(row.number) || 0;
//         totalQuantity += quantity;

//         flattenedData.push({
//           "Serial No": index + 1,
//           "Date": row.date,
//           [ReportFormat === "Material Wise" ? "Supplier" : "Material"]: row.supplier,
//           "Quantity": quantity.toFixed(2),
//           "Unit": row.unit,
//           "Material Name": materialItem.mat || "",
//         });
//       });
//       flattenedData.push({
//         "Serial No": "",
//         "Date": "",
//         [ReportFormat === "Material Wise" ? "Supplier" : "Material"]: "",
//         "Quantity": "",
//         "Unit": "Total",
//         "Material Name": totalQuantity.toFixed(2),
//       });
//     });

//   });

//   const ws = XLSX.utils.json_to_sheet(flattenedData);
//   const wb = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, "MaterialsReport");
//   XLSX.writeFile(wb, "MaterialsReport.xlsx");
// };

export const export_To_Excel = (
  data,
  ReportFormat,
  generatedBy,
  startDate,
  endDate
) => {
  console.log("data>?>?>??>?>", data);
  console.log("ReportFormat received:", ReportFormat);
  console.log("generatedBy", generatedBy);

  const flattenedData = [];
  flattenedData.push(["Enbuild"]);
  flattenedData.push([]);
  const generatedOn = new Date().toLocaleDateString();
  flattenedData.push([
    `Generated By: \n${generatedBy || "N/A"}`,
    `Generated On: \n${generatedOn}`,
    `Start Date: \n${startDate || "N/A"}`,
    `End Date: \n${endDate || "N/A"}`,
  ]);
  flattenedData.push([]);

  data.forEach(elem => {
    flattenedData.push([`Project Name: ${elem.projectName || ""}`]);
    flattenedData.push([]);

    elem.data.forEach(materialItem => {
      if (
        ReportFormat == "Material Wise" ||
        ReportFormat == "Crusher Sale Material"
      ) {
        flattenedData.push([`Material Name: ${materialItem.mat || ""}`]);
      } else if (
        ReportFormat == "Suppiler Wise" ||
        ReportFormat == "Suppiler Wise Labor" ||
        ReportFormat == "Crusher Sale Supplier"
      ) {
        flattenedData.push([`Supplier Name: ${materialItem.mat || ""}`]);
      } else if (ReportFormat == "Labours Wise") {
        flattenedData.push([`Labour Name: ${materialItem.mat || ""}`]);
      } else if (ReportFormat == "Contractor Wise") {
        flattenedData.push([`Contractor Name: ${materialItem.mat || ""}`]);
      } else if (ReportFormat == "Item Wise") {
        flattenedData.push([`Item Name: ${materialItem.mat || ""}`]);
      }

      if (
        ReportFormat == "Crusher Sale Supplier" ||
        ReportFormat == "Crusher Sale Material"
      ) {
        flattenedData.push([
          "Serial No",
          "Date",
          ReportFormat == "Crusher Sale Supplier" ? "Material" : "Supplier",
          "DC",
          "Location",
          "Quantity",
          "Unit",
        ]);
      } else {
        flattenedData.push([
          "Serial No",
          "Date",
          ReportFormat == "Material Wise" || ReportFormat == "Labours Wise"
            ? "Supplier"
            : ReportFormat == "Suppiler Wise Labor"
            ? "Labor"
            : ReportFormat == "Contractor Wise"
            ? "Item"
            : ReportFormat == "Item Wise"
            ? "Contractor"
            : "Material",
          "Quantity",
          "Unit",
        ]);
      }

      let totalQuantity = 0;
      materialItem.elm.forEach((row, index) => {
        if (
          ReportFormat == "Crusher Sale Supplier" ||
          ReportFormat == "Crusher Sale Material"
        ) {
          const quantity = parseFloat(row.quantity) || 0;
          totalQuantity += quantity;
          flattenedData.push([
            index + 1,
            row.date,
            ReportFormat == "Crusher Sale Supplier"
              ? row.partyMaterial
              : row.name,
            row.dc,
            row.location,
            quantity.toFixed(2),
            row.unit,
          ]);
        } else {
          const quantity = parseFloat(row.number) || 0;
          totalQuantity += quantity;
          flattenedData.push([
            index + 1,
            row.date,
            ReportFormat == "Contractor Wise"
              ? row.item
              : ReportFormat == "Labours Wise"
              ? row.supplier
              : ReportFormat == "Suppiler Wise Labor"
              ? row.labor
              : ReportFormat == "Item Wise"
              ? row.contractor
              : row.material,
            quantity.toFixed(2),
            row.unit,
          ]);
        }
      });

      flattenedData.push(["", "", "", "Total", totalQuantity.toFixed(2)]);
      flattenedData.push([]);
    });

    flattenedData.push([]);
  });

  const ws = XLSX.utils.aoa_to_sheet(flattenedData);

  ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }];

  const wb = XLSX.utils.book_new();
  // XLSX.utils.book_append_sheet(wb, ws, "MaterialsReport");
  // XLSX.writeFile(wb, `MaterialsReport.xlsx`);

  const sheetName =
    {
      "Material Wise": "materialWiseSupplier",
      "Crusher Sale Material": "crusherSaleMaterial",
      "Suppiler Wise": "supplierMaterial",
      "Suppiler Wise Labor": "supplierWiseLabour",
      "Crusher Sale Supplier": "CrusherSaleSupplier",
      "Labours Wise": "labourSupplier",
      "Contractor Wise": "contractorSupplier",
      "Item Wise": "itemSupplier",
    }[ReportFormat] || "MaterialsReport";

  XLSX.utils.book_append_sheet(wb, ws, sheetName);

  XLSX.writeFile(wb, `${sheetName}.xlsx`);
};

const downloadPDF = (filename, ori, data) => {
  console.log("full data", data);
  let defOri = ori == "p" ? "portrait" : ori == "l" && "landscape";
  let yourDate = new Date();
  yourDate = yourDate.toISOString().split("T")[0];
  const source = document.getElementById("download-section");
  var w = source.offsetWidth;
  var h = source.offsetHeight;
  var opt = {
    margin: 2,
    filename: filename + "-" + yourDate + ".pdf",
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2, dpi: 400 },
    pagebreak: { avoid: ".tableInside tr" },
    // pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
    jsPDF: { unit: "mm", format: "a4", orientation: defOri },
  };
  html2pdf().from(source).set(opt).save();
  // var w = source.offsetWidth;
  // var h = source.offsetHeight;
};

export default downloadPDF;
